export const redux_getAllProjects = (data: any) => ({
    type: 'GET_ALL_PROJECTS',
    payload: data,
});

export const redux_getProject = (data: any) => ({
    type: 'GET_PROJECT',
    payload: data,
});

export const redux_updateProject = (data: any) => ({
    type: 'UPDATE_PROJECT',
    payload: data,
});

export const redux_createProject = (data: any) => ({
    type: 'CREATE_PROJECT',
    payload: data,
});

export const redux_projectActionStarts = () => ({
    type: 'PROJECT_ACTION_STARTS',
});

export const redux_projectActionErrors = (error: string) => ({
    type: 'PROJECT_ACTION_ERRORS',
    payload: error,
});

export const redux_resetProjectErrors = () => ({
    type: 'RESET_PROJECT_ERRORS',
}); 